<!-- use tags -->

import Layout1 from "../../src/routes/guide-examples/+layout.marko";
import Page from "../../src/routes/guide-examples/skeleton-examples/in-order/example-2b/+page.marko";

<Layout1>
	<Page/>
</>
